import 'bootstrap/dist/css/bootstrap.css';
// Put any other imports below so that CSS from your
// components takes precedence over default styles.
import "./App.css";
import "./custom.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import routes from './routes';
import { SidebarProvider } from './Components/SidebarContext';

function App() {
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const [menuOpen, setMenuOpen] = useState(false);
  
  const handleMenuOpen = () => {
    setMenuOpen(!menuOpen);
  };

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  useEffect(() => {
    document.title = "EVChron";
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);
    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  // Function to safely render route components
  const renderRouteComponent = (Component) => {
    if (!Component) {
      console.error("Component is undefined or null");
      return <Navigate to="/" />;
    }
    
    try {
      return <Component />;
    } catch (error) {
      console.error("Error rendering component:", error);
      return <div>Error loading component</div>;
    }
  };

  return (
    <SidebarProvider>
      <Router>
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={renderRouteComponent(route.component)}
            />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} /> 
        </Routes>
      </Router>
    </SidebarProvider>
  );
}

export default App;